// extracted by mini-css-extract-plugin
export default {"textContainer":"styles_textContainer__zmjm5","small":"styles_small__GacM+","medium":"styles_medium__QIy4N","large":"styles_large__7Fa82"};